module.exports = __webpack_public_path__ + "img/icon-video.e799a08c.svg";